export default Object.freeze({
	CONTENT_CHANGED: 'szn.discussion.from.embed.pageChanged',
	ERROR: 'szn.discussion.from.embed.error',
	IDENTITY_FWD: 'szn.discussion.from.embed.identityFwd',
	LINK_REDIRECT: 'szn.discussion.from.embed.redirect',
	LOGIN: 'szn.discussion.from.embed.login',
	RESIZE: 'szn.discussion.from.embed.resize',
	SCROLL: 'szn.discussion.from.embed.scroll',
	SENTINEL_HANDSHAKE_ACK: 'szn.discussion.from.embed.sentinelHandshakeAck',
	SKIN_COLORS_FWD: 'szn.discussion.from.embed.skinColorsFwd',
	WIDGET: 'szn.discussion.from.embed.widget',
	OPEN_OAUTH_LOGIN: 'szn.discussion.from.embed.openOauthLogin',
	OPEN_LOGIN: 'szn.discussion.from.embed.openLogin',
	USER_IDENTITY: 'szn.discussion.from.embed.openUserIdentity',
	REQUEST_SOCIAL_TOKEN: 'szn.discussion.from.embed.requestSocialToken',
	SET_LOCAL_STORAGE_ITEMS: 'szn.discussion.from.embed.setLocalStorageItems',
	REMOVE_LOCAL_STORAGE_ITEMS: 'szn.discussion.from.embed.removeLocalStorageItems',
	UPDATE_BADGE: 'szn.discussion.from.embed.updateBadge',
	RENDER_ADD_BUTTON: 'szn.discussion.from.embed.renderAddButton'
});
